export default name =>
  name
    .toString()
    .toLowerCase()
    .replace(/\s+/g, ".") // Replace spaces with .
    .replace(/^-+/, "") // Trim - from start of text
    .replace(/-+$/, ""); // Trim - from end of text
